// 行程地圖每日顏色；放喺 Leaflet 以外，行程頁按鈕都用到而唔使載入地圖
export const DAY_COLORS = ['#d97706', '#0d9488', '#4f46e5', '#db2777', '#16a34a', '#0284c7', '#9333ea'];
export const dayColor = (i) => DAY_COLORS[i % DAY_COLORS.length];
